<template>
  <v-dialog v-model="localValue" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator" v-bind="{ on, attrs }"></slot>
    </template>
    <v-card class="flex-container">
      <v-card-title class="pa-0 flex-grow-0 header">
        <v-toolbar flat>
          <v-btn icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title>{{title}}</v-toolbar-title>

          <v-spacer></v-spacer>
          <slot name="header-actions">
            <v-btn icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </slot>

          <template v-slot:extension v-if="extensionSlotExists">
            <slot name="toolbar-extension"></slot>
          </template>
        </v-toolbar>
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text class="mt-1 flex-auto body" :class="{'pa-0': withoutPadding}" style="overflow-y: auto">
        <slot name="content"></slot>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="flex-grow-0 footer">
        <v-spacer></v-spacer>
        <slot name="footer-actions">
          <v-btn text color="error" @click="close">Annulla</v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  VDialog,
  VCard,
  VCardTitle,
  VToolbar,
  VBtn,
  VIcon,
  VToolbarTitle,
  VSpacer,
  VDivider,
  VCardText,
  VCardActions
} from "vuetify/lib";

export default {
  name: "FullScreenDialog",
  components: {
    VDialog,
    VCard,
    VCardTitle,
    VToolbar,
    VBtn,
    VIcon,
    VToolbarTitle,
    VSpacer,
    VDivider,
    VCardText,
    VCardActions
  },
  data: function() {
    return {
      localValue: this.value,
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: undefined
    },
    withoutPadding: {
      type: Boolean,
      default: false
    },
    routeFather: {
      type: String,
      default: ""
    }
  },
  methods: {
    close() {
      var self = this
      this.localValue = false;
      if(this.routeFather) {
        setTimeout(function() {
          self.$router.push({path: self.routeFather})
        }, 100)
      }
    }
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
    localValue(newVal) {
      if (newVal != this.value) {
        this.$emit("input", newVal);
      }
    }
  },
  computed: {
    extensionSlotExists() {
      return this.$slots['toolbar-extension'] != undefined && this.$slots['toolbar-extension'] != null
    }
  }
};
</script>

<style scoped>

.flex-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.header {
  height: fit-content;
}

.body {
  flex: 0 0 auto;
  flex-shrink: 1;
  flex-grow: 1
}

.footer {
  height: fit-content;
}
</style>